import React from "react";
import {
  SliderContainer,
  Label,
  LabelHint,
  MinMaxContainer,
  MinMaxLabel,
  StyledSlider,
} from "./CustomSlider.styles";

const CustomSlider = ({ label, label2, max, value, setValue, mt }) => {
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <SliderContainer mt={mt}>
      {label && <Label>{label}</Label>}
      {label2 && <LabelHint>{label2}</LabelHint>}
      <MinMaxContainer>
        <MinMaxLabel>{0}</MinMaxLabel>
        <MinMaxLabel>{max}</MinMaxLabel>
      </MinMaxContainer>
      <StyledSlider
        value={value}
        onChange={handleChange}
        min={0}
        max={max}
      />
    </SliderContainer>
  );
};

export default CustomSlider;
